import { useEffect, useRef } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom";

const SignUp = () => {
  const { signinRedirect } = useAuth();
  const navigate = useNavigate();
  const hasRun = useRef(false);

  useEffect(() => {
    document.title = "Sign Up | Kloudscan";
  }, []);

  useEffect(() => {
    window.history.scrollRestoration = "manual";
    window.onpageshow = (evt) => {
      if (evt.persisted) {
        window.location.reload();
      }
    };
  }, []);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const intent = localStorage.getItem("login_intent");

    if (intent === "from_header") {
      localStorage.removeItem("login_intent");

      const params = new URLSearchParams({
        client_id: process.env.REACT_APP_COGNITO_CLIENT_ID,
        redirect_uri: process.env.REACT_APP_COGNITO_REDIRECT_URI,
        response_type: "code",
        scope: "openid email profile",
      });

      window.location.href = `${process.env.REACT_APP_COGNITO_SIGNUP_URL}?${params.toString()}`;
      return;
    }

    navigate("/", { replace: true });
  }, [navigate, signinRedirect]);

  return (
    <Backdrop open sx={{ color: "#fff", zIndex: 9999 }}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default SignUp;
